import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import { compose } from "redux";
import { destroy } from "redux-form";
// i18n
import { withNamespaces } from "react-i18next";
// Constants
import { BASE_URL } from "../../../config/constants";
// Ducks
import { clearAdminUsers, getAdminUsers, setSelectedCandidate } from "./UsersList.ducks";
import { clearMissingExamsParts, resetLocationDetails } from "../Exams/Exams.ducks";
// Components
import Table from "../../../components/Table";
// Helpers
import { debounce } from "../../../services/helper";

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: undefined
    };
    this.debouncedSearchUsers = debounce(props.getAdminUsers, 500);
  }

  componentDidMount() {
    const { getAdminUsers, resetLocationDetails } = this.props;
    window.addEventListener(`resize`, this.resize);
    this.resize();
    resetLocationDetails();
    getAdminUsers({});
  }

  componentWillUnmount() {
    window.removeEventListener(`resize`, this.resize);
  }

  resize = () => {
    const { mobileDevice } = this.state;
    const isMobileDevice = window.innerWidth <= 760;

    if (isMobileDevice !== mobileDevice) {
      this.setState({ mobileDevice: isMobileDevice });
    }
  };

  getRowsData = () => {
    const { users } = this.props;
    const { mobileDevice } = this.state;

    return users.map((user) => ({
      lastName: user.lastName,
      firstName: user.firstName,
      login: user.login,
      email: user.email,
      trainingProvider: user.trainingProvider,
      id: user.id,
      ...(!mobileDevice && { options: true })
    }));
  };

  handleColumnNameClick = (params) => {
    const { getAdminUsers } = this.props;

    getAdminUsers(params);
  };

  handleRequestNextPage = (params) => {
    const { getAdminUsers } = this.props;

    getAdminUsers(params);
  };

  handleRowClick = ({ candidate, assign }) => (event) => {
    event.stopPropagation();
    const { clearMissingExamsParts, destroy, replace, setSelectedCandidate } = this.props;

    // Remove form state from the store so that the user does not see previously inserted that
    // This manual reset is needed because the form is configured with destroyOnUnmount as false
    // in order to not lose the state when navigating between examination dates
    destroy("examSearch");
    clearMissingExamsParts();
    setSelectedCandidate(candidate);
    assign ? replace(`${BASE_URL}/dashboard/assign`) : replace(`${BASE_URL}/dashboard/bookings`);
  };

  handleSearch = (params) => {
    clearAdminUsers();
    this.debouncedSearchUsers(params);
  };

  handleChangeTrainingProvider = (params) => {
    const { getAdminUsers } = this.props;

    clearAdminUsers();
    getAdminUsers(params);
  };

  render() {
    const { count, loading, t, trainingProviders, claims } = this.props;

    return (
      <div className="desktopContainer">
        <Table
          columns={[
            {
              key: `lastName`,
              value: t(`modules.localization.register.authenticated.usersList.lastName`)
            },
            {
              key: `firstName`,
              value: t(`modules.localization.register.authenticated.usersList.firstName`)
            },
            {
              key: `login`,
              value: t(`modules.localization.register.authenticated.usersList.login`)
            },
            {
              key: `email`,
              value: t(`modules.localization.register.authenticated.usersList.email`)
            },
            {
              key: `trainingProvider`,
              value: t(`modules.localization.register.authenticated.usersList.trainingProvider`, {
                count: 1
              })
            },
            { key: `id`, value: `ID` },
            {
              key: `options`,
              value: t(`modules.localization.register.authenticated.usersList.options`)
            }
          ]}
          emptyTableMessage={t(
            `modules.localization.register.authenticated.usersList.emptyTableMessage`
          )}
          handleRowClick={this.handleRowClick}
          handleColumnNameClick={this.handleColumnNameClick}
          handleSearch={this.handleSearch}
          handleChangeTrainingProvider={this.handleChangeTrainingProvider}
          trainingProvidersList={trainingProviders}
          isLoading={loading}
          requestNextPage={this.handleRequestNextPage}
          rows={this.getRowsData()}
          tableStyle={{
            margin: `5% auto 0`,
            width: "100%"
          }}
          title={t(`modules.localization.register.authenticated.usersList.candidates`)}
          totalResults={count}
          claims={claims}
        />
      </div>
    );
  }
}

UsersList.propTypes = {
  claims: PropTypes.array.isRequired,
  clearMissingExamsParts: PropTypes.func.isRequired,
  count: PropTypes.number,
  destroy: PropTypes.func.isRequired,
  getAdminUsers: PropTypes.func,
  loading: PropTypes.bool,
  replace: PropTypes.func,
  resetLocationDetails: PropTypes.func.isRequired,
  setSelectedCandidate: PropTypes.func,
  t: PropTypes.func,
  trainingProviders: PropTypes.array,
  users: PropTypes.array
};

const mapStateToProps = (state) => ({
  ...state.users,
  ...state.trainingProviders,
  claims: state.auth.claims
});

const mapDispatchToProps = {
  clearMissingExamsParts,
  destroy,
  getAdminUsers,
  replace,
  resetLocationDetails,
  setSelectedCandidate
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(UsersList);
